import { Navigate } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useTokens } from "@/hooks/useTokens";

export function IndexRedirect() {
  const { data: tokens, isLoading, isError, error, refetch } = useTokens();

  if (isLoading) {
    return (
      <div className="p-6 flex flex-col gap-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (isError) {
    console.error("IndexRedirect: failed to load tokens", error);
    return (
      <div className="p-6 flex flex-col gap-4 max-w-md">
        <Alert variant="destructive">
          <AlertTitle>Couldn't load your workspace</AlertTitle>
          <AlertDescription>
            {error.message ||
              "Failed to fetch tokens. Check your connection and try again."}
          </AlertDescription>
        </Alert>
        <Button
          variant="outline"
          onClick={() => {
            void refetch();
          }}
        >
          Retry
        </Button>
      </div>
    );
  }

  return (
    <Navigate
      to={tokens && tokens.length > 0 ? "/observability" : "/settings"}
      replace
    />
  );
}
